import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CsvExportService } from './csv-export.service';

@NgModule({
  imports: [CommonModule],
  providers: [CsvExportService],
})
export class CsvExportModule {}
